import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {Button} from 'iss/widgets/Buttons';
import {FormSection} from 'iss/widgets/Forms';
import {CollapsibleButtonPanel} from 'iss/widgets/Panels';
import {ContractLocationEditor} from 'iss/widgets/ContractLocationEditor';
import {SimpleContractSelector, showSelectedSite, subscribeToActivatedSitesByForm} from 'iss/widgets/selectors/EvaluationContractSelector';

const defaultSplit = {};

/* The splitting contract selector handles the splits as a property
 * named split in the returned contracts. To facilitate further selectors that
 * need to edit details for every split, the following function is provided to
 * convert a list of contracts with splits to a list of splits.
 *
 * The splitted contracts have also their id's changed to the form
 * contract.id-splitIndex so that components keying their lists with
 * contract.id can work fine.
 **/

export const toSplitContracts = R.unless(
  R.isNil,
  R.chain(contract => {
    const hasSplits = contract.splits && contract.splits.length;
    const locations = hasSplits ? contract.splits : [null];
    return locations.map((location, index) => (
      {...contract, location, id: contract.id+"-"+index, contractId: contract.id}
    ));
  })
);

export const SplittingContractSelector = subscribeToActivatedSitesByForm(
  ({isActivated, valuePath, ...props}) =>
  <React.Fragment>
    <p>{translate('batchEvaluationActivator.contractSelectorExternalIdHelp')}</p>
    <SimpleContractSelector multi={true} {...props} valuePath={valuePath} isActivated={isActivated}
      selectedItemFormatter={(contract, index) => <SiteSplitter site={contract.site} valuePath={[valuePath, index, 'splits']} isActivated={isActivated(contract.site)} />} />
  </React.Fragment>
);

function SiteSplitter({isActivated, site, valuePath}) {
  return <React.Fragment>
    {showSelectedSite(site, isActivated)}
    {" "}
    <FormSection valuePath={valuePath}>
      {(splits, formApi) =>
        <CollapsibleButtonPanel id={`split-site-${site.id}`} buttonText={translate('batchEvaluationActivator.splitContract')} initiallyOpen={splits && splits.length}>
        <div className="well well-sm">
          {splits && splits.map((split, index) =>
            <ContractLocationEditor inline key={index} valuePath={index}
              id={`site-${site.id}-split-${index}`}
              onRemove={() => formApi.updateValue([], R.remove(index, 1))} />
          )}
          <Button id={`add-split-to-${site.id}`} onClick={() => formApi.updateValue([], R.append(defaultSplit))}
            text={translate('batchEvaluationActivator.addLocation')}/>
        </div>
        </CollapsibleButtonPanel>
      }
    </FormSection>
  </React.Fragment>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/selectors/SplittingContractSelector.jsx